var render = function render(){var _vm=this,_c=_vm._self._c;return _c('cm-sidebar',{attrs:{"isMultipleMode":false,"isCurssusPage":true,"loading":_vm.loading,"courseList":_vm.courseList,"selector":_vm.selector},on:{"needToUpdateData":_vm.loadData,"click:select":_vm.selectDate}})
}
var staticRenderFns = []

export { render, staticRenderFns }